// src/utils/referral.js
// Salesperson tracking helper for QuizHub & GamesHub purchases.
// Captures the salesperson code from ?ref= / ?sales= on the URL (once) and
// persists it in localStorage so it survives navigation and is attached to the
// next purchase. Tracking only — no commission logic.

const KEY = 'flyhighSalesCode'

function readQueryParam() {
  if (typeof window === 'undefined' || !window.location) return null
  const params = new URLSearchParams(window.location.search)
  for (const name of ['ref', 'sales', 'sp', 'salesCode']) {
    const val = (params.get(name) || '').trim()
    if (val) return val
  }
  return null
}

// Capture ?ref= / ?sales= once and persist. Safe to call on every mount.
export function captureSalesCode() {
  if (typeof window === 'undefined') return
  const code = readQueryParam()
  if (code) {
    try { localStorage.setItem(KEY, code) } catch (e) { /* ignore */ }
  }
}

export function getSalesCode() {
  try {
    return localStorage.getItem(KEY) || ''
  } catch (e) {
    return ''
  }
}

export function clearSalesCode() {
  try { localStorage.removeItem(KEY) } catch (e) { /* ignore */ }
}
